import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  className = '',
  label,
  error,
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-159">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-stone-700 mb-1.5" data-id="element-160">
          {label}
        </label>}
      <input id={inputId} className={`flex h-12 w-full rounded-xl border border-stone-200 bg-white px-4 py-2 text-base ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-stone-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stone-400 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${className}`} {...props} data-id="element-161" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-162">{error}</p>}
    </div>;
}